'use client';

import Box from '@/components/ui/Box';
import Btn from '@/components/ui/Btn';
import { useTranslations } from 'next-intl';
import * as style from './LayoutProtected.css';
import useProtectedEntry from './useProtectedEntry';

type LayoutProtectedActionsBarProps = {
  entryId: string;
};

const LayoutProtectedActionsBar = ({ entryId }: LayoutProtectedActionsBarProps) => {
  const { handleLogout } = useProtectedEntry(entryId);
  const t = useTranslations('protected');

  return (
    <div className={style.actionBar}>
      <Box colorSet="neutralLight" paper cx={{ padding: 'xs', borderRadius: 'sm' }}>
        <Btn onClick={handleLogout} startIcon="lock" variant="nav" size="small">
          {t('logout')}
        </Btn>
      </Box>
    </div>
  );
};

export default LayoutProtectedActionsBar;
